import { dateStringToHumanReadableDate } from "../../utils/valueFormatting";
import React from "react";
import {
  BoardSummaryContainer,
  BoardSummaryDetail,
  InputLabel,
} from "./ShipmentSummaryStyles";
import ProjectOwner from "../ShareBoard/ProjectOwner";
import Link from "next/link";
import getBoardLink from "../../utils/links/boards";
import LoadingIcon from "../common/LoadingIcon";
import {
  Board,
  ProductionStatus,
  Shipment,
} from "../../reducers/uploadedBoard";
import { useBoard } from "../../utils/hooks/commonly-stored/uploaded-board/board";
import {
  useShipment,
  useShipments,
} from "../../utils/hooks/commonly-stored/uploaded-board/shipments";

export function ShipmentSummaryDetail({
  board,
  shipment,
  showBoardOwner = true,
}: {
  board: Board;
  shipment: Shipment;
  showBoardOwner?: boolean;
}) {
  const shipmentDetail = () => {
    return (
      <div>
        <InputLabel>Ship date:</InputLabel>
        {dateStringToHumanReadableDate(shipment.ship_date)}
      </div>
    );
  };
  return (
    <BoardSummaryContainer>
      <BoardSummaryDetail>
        <Link
          href={getBoardLink(board.id, true, shipment.id)}
          target={"_blank"}
        >
          {board.project_name}
        </Link>
      </BoardSummaryDetail>
      <BoardSummaryDetail>
        <div>
          <InputLabel>Id:</InputLabel>
          {board.id}
        </div>
        {shipmentDetail()}
      </BoardSummaryDetail>
      {showBoardOwner && board.user_id !== null && (
        <ProjectOwner boardId={board.id} userId={board.user_id} />
      )}
    </BoardSummaryContainer>
  );
}

export default function ShipmentSummaryDetailFromIds({
  boardId,
  shipmentId,
  showBoardOwner = true,
}: {
  boardId: string;
  shipmentId: string;
  showBoardOwner?: boolean;
}) {
  const { board } = useBoard(boardId);
  const { shipment } = useShipment(boardId, shipmentId);

  if (board === null || shipment === null) {
    return <LoadingIcon text={"Loading shipment..."} />;
  }

  return (
    <ShipmentSummaryDetail
      board={board}
      shipment={shipment}
      showBoardOwner={showBoardOwner}
    />
  );
}

export function BoardNextShipmentDetail({ boardId }: { boardId: string }) {
  const { board } = useBoard(boardId);
  const { shipments } = useShipments(boardId);

  if (board === null || shipments === null) {
    return <LoadingIcon text={"Loading shipment..."} />;
  }

  const nextShipment = shipments.find(
    (shipment) => shipment.production_status == ProductionStatus.MANUFACTURING,
  );
  return (
    <ShipmentSummaryDetail
      board={board}
      shipment={nextShipment || (shipments.at(-1) as Shipment)}
    />
  );
}
